(function ($) {
    $(document).ready(function () {
        setTimeout(function () {
  $("#tidio-chat-iframe").css({ width: "100px" });

  $(document).off("mousemove.tidioFix").on("mousemove.tidioFix", function () {
    const height = $("#tidio-chat-iframe").css("height");

    // iframe이 없거나 height가 비어있으면 아무것도 하지 않음
    if (!height) return;

    const m = height.match(/\d+/);
    if (!m) return;

    if (parseInt(m[0], 10) < 100) {
      $("#tidio-chat-iframe").css({ width: "100px" });
    }
  });
}, 3000);
        
        $('.hero-slider-init').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            useTransform: false,
            speed: 600,
            arrows: true,
            prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'></button>",
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
                    dots: true,
                  }
                }
            ]
        });

        if($('.js-offer-readmore').length > 0) {
            $('.js-offer-readmore').each(function(){
                $(this).on('click', function(e){
                    let container = $(this).closest('.offer-description');
                    $(this).hide();
                    $(container).find('.excerpt').hide();
                    $(container).find('.full').show();
                })
            })
        }
          
        /**Init Home blog widget */
        let widgets = $(".home-blog-widget-slider");

        if($(widgets).length > 0) {
          $(widgets).each(function() {
            $(this).slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                responsive: [
                    {
                      breakpoint: 1132,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                      }
                    },
                    {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1.3,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
          })
        }

        /** Featured slider */
        let featuredSliders = $(".feature-section-slider");

        if($(featuredSliders).length > 0) {
          $(featuredSliders).each(function() {
            $(this).slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      dots: true,
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: false
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      dots: true,
                      slidesToShow: 1.39,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
          })
        }

        /** Featured products slider */
        let featuredProductsSliders = $(".featured-products-slider");

        if($(featuredProductsSliders).length > 0) {
          $(featuredProductsSliders).each(function() {
            $(this).slick({
                infinite: false,
                dots: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true,
                prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'></button>",
                responsive: [
                  {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1.39,
                      slidesToScroll: 1,
                      arrows: false
                    }
                  }
                ]
            });
          })
        }

        /** Featured products slider */
        let productsSliders = $(".section-products-grid");

        if($(productsSliders).length > 0) {
          $(productsSliders).each(function() {
            $(this).slick({
                dots: true,
                arrows: false,
                infinite: false,
                responsive: [
                  {
                    breakpoint: 9999,
                    settings: "unslick",
                    dots: false
                  },
                  {
                    breakpoint: 650,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1.39,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
          })
        }

      function addHeaderHeight() {
        let height = $('.site-header').outerHeight(true);
        $('.site-header-sticky').css('min-height', height);
      }

      addHeaderHeight();
      
    });
})(jQuery);